module.exports = __webpack_public_path__ + "img/20200613_095959.de784f47.jpg";